<template>
  <div :class="componentClasses">
    <div class="bar-item">
      <h3 v-if="config.showTitle" class="title" v-html="translatedTitle"></h3>
      <h4
        v-if="config.showSubtitle"
        class="subtitle"
        v-html="tranlsatedSubtitle"
      ></h4>
      <div :class="graphClasses">
        <div class="bar">
          <span class="value" :style="barStyles"></span>
        </div>
        <div v-if="config.showPercentage" class="value">{{ bar }}%</div>
      </div>
    </div>
  </div>
</template>
<script>
import TranslationMixin from '@/lib/TranslationMixin';
import { getScoringTranslationContext } from '@/lib/Helpers.js';
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        {
        }
      },
    },
  },
  created() {
    this.localConfig = this.config;
    this.$watch('localConfig', this.onChange, { deep: true });
  },
  inject: ['theme', 'blockTranslationContext'],
  mixins: [TranslationMixin],
  components: {},
  computed: {
    translatedTitle() {
      const translated = this.$t(
        this.config.title,
        this.blockTranslationContext + '.options.title'
      );
      const banded = this.bandedText(translated);
      return banded;
    },
    tranlsatedSubtitle() {
      const translated = this.$t(
        this.config.subtitle,
        this.blockTranslationContext + '.options.subtitle'
      );
      const banded = this.bandedText(translated);
      return banded;
    },
    graphClasses() {
      const additionalClasses = this.config.showPercentage
        ? 'with-text'
        : 'without-text';
      return `bar-graph ${additionalClasses}`;
    },
    barStyles() {
      return {
        backgroundColor: this.band.colour || this.config.barColor,
        width: this.bar + '%',
      };
    },
    componentClasses() {
      let bandName = this.band.name.replace(/[^a-zA-Z0-9]/, '').toLowerCase();
      return `progress-bar progress-${bandName}`;
    },
    band() {
      let score = this.$store.state.scoreCache[this.config.scoreSet];
      return score.banding[this.config.query];
    },
    scoringTranslationContext() {
      const scoring = this.$store.state.config.scoring;
      const context = getScoringTranslationContext(
        scoring,
        this.config.scoreSet,
        this.band.id
      );
      return context;
      return `scoring.${scoreSetIndex}.bands.${bandIndex}`;
    },
    bar() {
      return this.band.percent * 100;
    },
  },
  methods: {
    bandedText(text) {
      return text.replace(
        /\$band\$/,
        `<span class='band' style='color: ${this.band.colour}'>` +
          this.$t(this.band.name, 'name', this.scoringTranslationContext) +
          '</span>'
      );
    },
    onChange() {
      this.$emit('change', this.config);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../scss/progress-bar';
</style>
